import { render, staticRenderFns } from "./ReportType.vue?vue&type=template&id=44a6520e&scoped=true&"
import script from "./ReportType.vue?vue&type=script&lang=js&"
export * from "./ReportType.vue?vue&type=script&lang=js&"
import style0 from "./ReportType.vue?vue&type=style&index=0&id=44a6520e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a6520e",
  null
  
)

export default component.exports